import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import HTMLViewer from "./HTMLViewer";
import QuillRTE from "./QuillRTE";

export default function RichTextNotes(props) {
  const [content, setContent] = useState(props?.content || "");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setContent(props?.content || "");
    }
  }, [props?.content, open]);

  const handleOpen = () => {
    setContent(props?.content || "");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    if (props?.onUpdate) {
      props.onUpdate(content);
    }
    setOpen(false);
  };

  if (!open) {
    return (
      <Box>
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            padding: 2,
          }}
        >
          {content ? (
            <HTMLViewer content={content} />
          ) : (
            <Typography variant="body1" color="textSecondary" sx={{ fontStyle: "italic" }}>
              {props?.placeholder || "No content added yet..."}
            </Typography>
          )}
        </Box>
        <Box mt={2}>
          <Button fullWidth color="secondary" variant="outlined" onClick={handleOpen}>
            Edit
          </Button>
        </Box>
      </Box>
    );
  } else {
    return (
      <Dialog fullWidth maxWidth="md" open={open} scroll="paper" onClose={handleClose}>
        <DialogTitle
          sx={{
            padding: "7px 20px",
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0",
            backgroundColor: "#DEDEDE",
            borderBottom: "3px solid #DEDEDE",
          }}
        >
          <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <IconButton onClick={handleClose}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5">Edit Notes</Typography>
          </Box>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#F7F7F7" }}>
          <Box pt={4}>
            <Paper elevation={0}>
              <QuillRTE value={content} onChange={(html) => setContent(html)} />
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button fullWidth color="primary" variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
